/**
 * Setup global de TanStack Query.
 *
 * Configuración mínima para WEB-7.1: cache de 30s por default (evita
 * thrash al cambiar de página y volver), 1 retry automático, no
 * refetch al focus (la mayoría de pantallas no son tiempo real).
 *
 * Iteraciones siguientes pueden subir `staleTime` por query específica
 * (ej. lista de projects → 5 min; runs en vuelo → polling 5s).
 */

import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
